(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hs-mobile-sticky-atc"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.hsStickyAtcInitialized) return;
    window.hsStickyAtcInitialized = true;

    const initialize = (bar) => {
      if (bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';
      const productInfo = bar.closest('product-info');
      if (!productInfo) return;
      const sectionId = bar.dataset.sectionId;
      const variants = JSON.parse(bar.querySelector('[data-hs-sticky-variants]').textContent);
      const originalButton = () => document.getElementById(`ProductSubmitButton-${sectionId}`);
      const variantInput = () => document.querySelector(`#product-form-${sectionId} input[name="id"]`);

      const sync = () => {
        const input = variantInput();
        const variant = variants.find((item) => String(item.id) === String(input?.value));
        if (!variant) return;
        bar.querySelector('[data-hs-sticky-variant]').textContent = variant.title;
        bar.querySelector('[data-hs-sticky-price]').textContent = variant.price;
        const button = bar.querySelector('[data-hs-sticky-submit]');
        button.disabled = !variant.available;
        button.textContent = variant.available ? bar.dataset.addLabel : bar.dataset.soldOutLabel;
      };

      bar.querySelector('[data-hs-sticky-submit]').addEventListener('click', () => {
        const button = originalButton();
        if (button && !button.disabled) button.click();
      });

      productInfo.addEventListener('change', () => window.setTimeout(sync, 120));
      const attachVariantListener = () => {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) === String(sectionId)) sync();
        });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attachVariantListener, { once: true });
      } else {
        attachVariantListener();
      }
      const purchase = productInfo.querySelector('.hs-pdp-purchase');
      if (purchase) {
        new IntersectionObserver(([entry]) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        }).observe(purchase);
      }
      sync();
    };

    const hydrate = (root = document) => root.querySelectorAll('[data-hs-mobile-atc]').forEach(initialize);
    hydrate();
    document.addEventListener('shopify:section:load', (event) => hydrate(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-product-delivery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.hsDeliveryWindowInitialized) return;
    window.hsDeliveryWindowInitialized = true;

    const addBusinessDays = (date, days) => {
      const result = new Date(date);
      let added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
      }
      return result;
    };

    const formatWindow = (element) => {
      if (element.dataset.ready === 'true') return;
      const minimum = Number(element.dataset.minDays || 2);
      const maximum = Number(element.dataset.maxDays || 4);
      const start = addBusinessDays(new Date(), minimum);
      const end = addBusinessDays(new Date(), maximum);
      const formatter = new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'short' });
      element.textContent = `zwischen ${formatter.format(start)} und ${formatter.format(end)}`;
      element.dataset.ready = 'true';
    };

    const hydrate = (root = document) => {
      root.querySelectorAll('[data-hs-ready-window]').forEach(formatWindow);
    };

    hydrate();
    new MutationObserver(() => hydrate()).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hs-size-assist"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.hsSizeAssistInitialized) return;
    window.hsSizeAssistInitialized = true;

    const updateSelection = (root) => {
      const productInfo = root.closest('product-info');
      if (!productInfo) return;
      const expectedName = `options[${root.dataset.optionName}]`;
      const controls = Array.from(productInfo.querySelectorAll('[data-option-name], [name^="options["]'));
      const control = controls.find((item) => {
        const matchesOption = item.dataset.optionName === root.dataset.optionName || item.name === expectedName;
        return matchesOption && (item.type !== 'radio' || item.checked);
      });
      if (!control) return;
      const value = control.value;
      const output = root.querySelector('[data-hs-size-value]');
      if (output && output.textContent.trim() !== value) output.textContent = value;
      root.querySelectorAll('.hs-size-dialog__sizes span').forEach((item) => {
        item.classList.toggle('is-selected', item.textContent.trim() === value);
      });
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-hs-size-open]');
      if (openButton) {
        const dialog = document.getElementById(openButton.getAttribute('aria-controls'));
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-hs-size-close]');
      if (closeButton) closeButton.closest('dialog')?.close();
      if (event.target.matches('[data-hs-size-dialog]')) event.target.close();
    });

    document.addEventListener('change', (event) => {
      const productInfo = event.target.closest('product-info');
      if (!productInfo) return;
      window.setTimeout(() => {
        productInfo.querySelectorAll('[data-hs-size-assist]').forEach(updateSelection);
      }, 120);
    });

    const attachVariantListener = () => {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
        productInfo?.querySelectorAll('[data-hs-size-assist]').forEach(updateSelection);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachVariantListener, { once: true });
    } else {
      attachVariantListener();
    }

    new MutationObserver(() => {
      document.querySelectorAll('[data-hs-size-assist]').forEach(updateSelection);
    }).observe(document.body, { childList: true, subtree: true });

    document.querySelectorAll('[data-hs-size-assist]').forEach(updateSelection);
  })();
  } catch(e) { console.error(e); }
})();

})();
